export { default as ListClasses } from './List'
export { default as CreateClass } from './Create'
export { default as ShowClass } from './Show'
export { default as EditClass } from './Edit'
